module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addLabels
    }
  }, [_vm._v("添加关联打印机")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.printerShopList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "打印机名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "120px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "打印机名称"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "placeholder": "打印机名称"
      },
      model: {
        value: (_vm.form.name),
        callback: function($$v) {
          _vm.$set(_vm.form, "name", $$v)
        },
        expression: "form.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "店铺"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (_vm.distributor),
        callback: function($$v) {
          _vm.distributor = $$v
        },
        expression: "distributor"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("总部")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 2
      }
    }, [_vm._v("店铺")])], 1)], 1), _vm._v(" "), (_vm.distributor == 2) ? _c('el-form-item', {
      attrs: {
        "label": "所属店铺"
      }
    }, [_vm._l((_vm.relDistributors), function(item, index) {
      return _c('el-tag', {
        key: index,
        staticClass: "new-tag",
        attrs: {
          "closable": "",
          "disable-transitions": false
        },
        on: {
          "close": function($event) {
            return _vm.handleClose(index)
          }
        }
      }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                    ")])
    }), _vm._v(" "), _c('el-button', {
      staticClass: "button-new-tag",
      attrs: {
        "size": "medium"
      },
      on: {
        "click": _vm.addDistributoreAction
      }
    }, [_vm._v("+ 点击搜索店铺\n                    ")])], 2) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "打印机终端号"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "placeholder": "打印机名称"
      },
      model: {
        value: (_vm.form.app_terminal),
        callback: function($$v) {
          _vm.$set(_vm.form, "app_terminal", $$v)
        },
        expression: "form.app_terminal"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("见打印机底部")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "打印机秘钥"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "placeholder": "打印机名称"
      },
      model: {
        value: (_vm.form.app_key),
        callback: function($$v) {
          _vm.$set(_vm.form, "app_key", $$v)
        },
        expression: "form.app_key"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("见打印机底部")])], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitAction
      }
    }, [_vm._v("保存")])], 1)
  ], 2), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.DistributorVisible,
      "is-valid": _vm.isValid,
      "rel-data-ids": _vm.relDistributors,
      "get-status": _vm.DistributorStatus
    },
    on: {
      "chooseStore": _vm.DistributorChooseAction,
      "closeStoreDialog": _vm.closeDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-450c0ac7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-450c0ac7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/yilianyun/shop.vue
// module id = 2676
// module chunks = 0